import { render, staticRenderFns } from "./historyModal.vue?vue&type=template&id=0bcd4f20"
import script from "./historyModal.vue?vue&type=script&lang=js"
export * from "./historyModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports